import { Text } from 'pcln-design-system'
import { Gps } from 'pcln-icons'
import PropTypes from 'prop-types'
import DropdownItem from './DropdownItem'

const renderDisplayText = current => {
  if (current.matches('pending')) {
    return 'Locating...'
  }
  if (current.matches('rejected')) {
    if (current.context.error) {
      return 'Having Issue Locating, Please try again'
    }
    return 'Location Sharing Disabled'
  }
  return 'Use Current Location'
}

const RenderCurrentLocation = ({
  handleRequestCurrentLocationClick,
  current
}) => {
  return (
    <DropdownItem onMouseDown={handleRequestCurrentLocationClick}>
      <Gps color="primary" mx={2} size={24} />
      <Text py={12} mr={2} fontSize={0}>
        {renderDisplayText(current)}
      </Text>
    </DropdownItem>
  )
}

RenderCurrentLocation.propTypes = {
  handleRequestCurrentLocationClick: PropTypes.func,
  current: PropTypes.object
}

export default RenderCurrentLocation
